import classnames from 'classnames'
import React, { DetailedHTMLProps, InputHTMLAttributes, forwardRef } from 'react'
import IconTooltip from '../IconTooltip'

interface Props {
  name?: string
  label?: string | Array<string | HTMLElement>
  infoTip?: string | React.ReactNode
  startAdornment?: React.ReactNode
  endAdornment?: React.ReactNode
  errorMessage?: string
}

const InputField = forwardRef<
  HTMLInputElement,
  Props & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
>(
  (
    {
      name,
      label,
      infoTip,
      startAdornment,
      endAdornment,
      className,
      errorMessage,
      disabled,
      ...rest
    },
    ref
  ) => {
    return (
      <div
        className={classnames('input-field', {
          'input-field-has-error': !!errorMessage,
          'input-field-has-disabled': disabled,
        })}
      >
        {label && (
          <div className='input-field-label'>
            <label htmlFor={name}>{label}</label>{' '}
            {infoTip && (
              <IconTooltip
                place='top'
                iconClassName='fal fa-info-circle input-field-infotip'
                popupContent={infoTip}
              />
            )}
          </div>
        )}
        <div className='input-field-input'>
          {startAdornment && (
            <span className='input-field-adornment input-field-adornment-start'>
              {startAdornment}
            </span>
          )}
          <input
            id={name}
            name={name}
            disabled={disabled}
            className={className}
            ref={ref}
            {...rest}
          />
          {endAdornment && (
            <span className='input-field-adornment input-field-adornment-end'>{endAdornment}</span>
          )}
        </div>
        {errorMessage && <div className='input-field-error'>{errorMessage}</div>}
      </div>
    )
  }
)

InputField.displayName = 'InputField'
export default InputField
